import endpoint from "../../config/endpoints";

export const ReceivedOrderPageJson = {
    showSaveNextBtn: false,
    showAddButton: false,
    apiBaseURL: endpoint.area,
    screenTitle: "Received Order",
    formPathView: "/place-order-view",
    formPath: "/order-edit",

    tableColumnsToFilter: [
        {
            columnDisplayName: "Order No",
            columnKeyName: "orderNo",
            isChecked: true,
        },
        {
            columnDisplayName: "Taken By",
            columnKeyName: "orderTakenByName",
            isChecked: true,
        },

        {
            columnDisplayName: "Stock Holder Name",
            columnKeyName: "dealerFirmName",
            isChecked: true,
        },

        {
            columnDisplayName: "Status",
            columnKeyName: "statusName",
            isChecked: true,
        },
    ],
    searchList: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "toDate",
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
            isMandatory: true,
            onSubmit: "compare",
        },
    ],
};
